import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AmplifyService } from '@app-services/amplify.service';
import { SessionStore } from '@app/store/session/session.store';

@Component({
  selector: 'app-dealer-unauthorized',
  templateUrl: './dealer-unauthorized.component.html',
  styleUrls: ['./dealer-unauthorized.component.scss']
})
export class DealerUnauthorizedComponent implements OnInit {

  status;
  constructor(public route: ActivatedRoute, private amplifyService: AmplifyService, private sessionStore: SessionStore) {
    this.route.data.subscribe(data => this.status = data.status);
  }

  ngOnInit() {
    this.amplifyService.logout();
    this.sessionStore.clearSession();
  }

}
